import {user_formatted_date, user_formatted_time} from 'helpers/date'

const AuctionEndOrStart = ({
    upcoming, 
    expire_date, 
    active_date, 
    user: { timezone = 'America/Phoenix' } = {}
}) => {
    
    return !upcoming ? ( 
        <div className="details-expires">
                Auction ends on
                {' '}
                <div className="ends-on-xs-break" />
                <strong>{user_formatted_date(expire_date)}</strong>
                {' '}
                at
                {' '}
                <strong>{user_formatted_time(expire_date)}</strong>
                <br />
                (
                    {timezone}
                )
            </div>
    ) : (
        <div className="details-expires">
            Auction starts on
            {' '}
            <div className="ends-on-xs-break" />
            <strong>{user_formatted_date(active_date)}</strong>
            {' '}
            at
            {' '}
            <strong>{user_formatted_time(active_date)}</strong>
            <br />
            (
                {timezone}
            )
        </div>
    )
}

export default AuctionEndOrStart